export default "__VITE_ASSET__CBGpaqMh__"